import apiSlice from "./ApiSlice";

const dashboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllFacultyWiseData: builder.mutation({
      // providesTags: ["reports"],
      query: (body: any) => {
        return {
          url: "/reports/faculty-wise-count",
          method: "POST",
          body,
        };
      },
    }),

    // get all delivery dates
    getAllCourseWitseData: builder.mutation({
      // providesTags: ["reports"],
      query: (body: any) => {
        return {
          url: "/reports/course-wise-count",
          method: "POST",
          body,
        };
      },
    }),
    // delete delivery date
    deleteCourseById: builder.mutation({
      invalidatesTags: ["course"],
      query: (id: any) => ({
        url: `/course/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addCourse: builder.mutation({
      invalidatesTags: ["course"],
      query: (body) => ({
        url: `/course/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getCourseById: builder.query({
      providesTags: ["course"],
      query: (id: string) => {
        return {
          url: `/course/${id}`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateCourseById: builder.mutation({
      invalidatesTags: ["course"],
      query: ({ body, id }) => ({
        url: `/course/${id}`,
        method: "PUT",
        body,
      }),
    }),

    //get Course
    getAllCourse: builder.query({
      providesTags: ["course"],
      query: () => {
        return {
          url: `/course`,
          method: "GET",
        };
      },
    }),

    // change status of delivery date
    changeStatusCourseById: builder.mutation({
      invalidatesTags: ["course"],
      query: ({ body, id }) => ({
        url: `/course/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
    // change status of delivery date
    getAllSalesReport: builder.mutation({
      query: (body) => ({
        url: `/reports/sales-report`,
        method: "POST",
        body,
      }),
    }),
    getAllFollowupsReport: builder.query({
      query: (body) => ({
        url: `/reports/followup`,
        method: "POST",
        body,
      }),
    }),
    // due amount report
    getDueAmountReport: builder.query({
      providesTags: ["due"],
      query: (body) => ({
        url: `/reports/order-due`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllFacultyWiseDataMutation,
  useGetAllCourseWitseDataMutation,
  useDeleteCourseByIdMutation,
  useAddCourseMutation,
  useGetAllCourseQuery,
  useGetCourseByIdQuery,
  useUpdateCourseByIdMutation,
  useChangeStatusCourseByIdMutation,
  useGetAllSalesReportMutation,
  useGetDueAmountReportQuery,
  useGetAllFollowupsReportQuery,
} = dashboardApi;
